import { render, staticRenderFns } from "./DidYouKnow.vue?vue&type=template&id=196fdd92&scoped=true"
import script from "./DidYouKnow.vue?vue&type=script&lang=js"
export * from "./DidYouKnow.vue?vue&type=script&lang=js"
import style0 from "./DidYouKnow.vue?vue&type=style&index=0&id=196fdd92&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "196fdd92",
  null
  
)

export default component.exports